import { render, staticRenderFns } from "./admin-deduct.vue?vue&type=template&id=721da74b&scoped=true&"
import script from "./admin-deduct.vue?vue&type=script&lang=js&"
export * from "./admin-deduct.vue?vue&type=script&lang=js&"
import style0 from "./admin-deduct.vue?vue&type=style&index=0&id=721da74b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721da74b",
  null
  
)

export default component.exports